import { Container } from "@mui/material";
import { AddMaterial } from "../Roofs/AddMaterial";
import { VentsTable } from "./VentsTable";
import { FC, useState } from "react";
import { Material } from "../../../../redux/types/Material";

interface VentsMatProps {
  onDone: Function;
  materials?: Material[];
}

export const VentsMaterials: FC<VentsMatProps> = ({ onDone, materials }) => {
  const [addMaterial, setAddMaterial] = useState(false);

  const onDisplayAddMaterial = () => {
    setAddMaterial(!addMaterial);
  };

  if (addMaterial) {
    return (
      <Container>
        <AddMaterial
          matType="vents"
          onCancel={() => setAddMaterial(false)}
          onTapAdd={() => {
            setAddMaterial(false);
            onDone("vents");
          }}
        />
      </Container>
    );
  } else {
    return (
      <VentsTable
        materials={Array.isArray(materials) ? materials : []}
        onUploadVents={() => onDisplayAddMaterial()}
      />
    );
  }
};
